import apiClient from "../../../../../../services/apiClient";

export async function getInfoChildrenWPlace({childId}){


    const url=`children_kg/${childId}`;

    const response = await apiClient.get(url);

    return response.data[0];

}

export async function checkMRParentKG({childId, parentInd}){

    const url=`checkMRParentKg`;

    const body = {id: childId, par: parentInd};

    const result = await apiClient.post(url, body);
    
    return result;


}